module.exports = __webpack_public_path__ + "img/sith.e2c913bc.svg";